<template>
    <aside
        class="main-sidebar sidebar-dark-primary elevation-4 hide-scrollbar"
        style="z-index: 200 !important"
    >
        <router-link :to="{ name: 'Home' }" class="brand-link">
            <!-- <img
        src="../../assets/logo.png"
        alt="AdminLTE Logo"
        class="brand-image img-circle elevation-3"
        style="opacity: 0.8"
      /> -->
            <span class="brand-text font-weight-light"
                ><strong>PushMyROI</strong></span
            >
        </router-link>
        <div class="sidebar overflow-hidden" style="height: fit-content">
            <div class="user-panel mt-3 pb-3 mb-3 d-flex">
                <div class="info" style="background-color: unset !important">
                    <div
                        class="d-block name-block"
                        id="user_name"
                        style="height: 24px"
                        v-cloak
                    >
                        {{ userName }} - {{ roles[0] || "" }}
                    </div>
                </div>
            </div>
            <v-divider></v-divider>
            <!-- Sidebar Menu -->
            <nav class="mt-2" style="margin: 0 !important">
                <ul
                    class="nav nav-pills nav-sidebar flex-column"
                    data-widget="treeview"
                    role="menu"
                    data-accordion="false"
                >
                    <!-- Dashboard -->
                    <li class="nav-item has-treeview">
                        <router-link
                            class="nav-link"
                            :to="{ name: 'Dashboard' }"
                            id="main_dashboard"
                        >
                            <em class="nav-icon bi-speedometer2 mr-2"></em>
                            <p>Main Dashboard</p>
                        </router-link>
                    </li>
                    <!-- Users Management -->
                    <li
                        class="nav-item has-treeview"
                        v-if="isUserManagementAvailable"
                    >
                        <router-link
                            class="nav-link"
                            :to="{ name: 'UsersManagement' }"
                            id="users_management"
                        >
                            <em class="nav-icon bi-people mr-2"></em>
                            <p>Users Management</p>
                        </router-link>
                    </li>
                    <!-- Administration -->
                    <li
                        class="nav-item has-treeview"
                        v-if="isDevSettingsAvailable"
                    >
                        <div
                            class="nav-link"
                            id="dev_settings"
                            :to="{ name: 'Clients' }"
                        >
                            <i class="mr-2 bi-file-earmark-code"></i>
                            <p>
                                Dev Settings
                                <em class="bi-chevron-right right"></em>
                            </p>
                        </div>
                        <ul class="nav nav-treeview">
                            <li class="nav-item">
                                <router-link
                                    class="nav-link"
                                    id="clients"
                                    tag="div"
                                    :to="{ name: 'Clients' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Clients</p>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                    class="nav-link"
                                    id="roles"
                                    tag="div"
                                    :to="{ name: 'Roles' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Roles</p>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                    class="nav-link"
                                    id="clusters"
                                    tag="div"
                                    :to="{ name: 'Clusters' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Clusters</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <!-- Main Stats -->
                    <!-- <li
                        class="nav-item has-treeview"
                        style="cursor: pointer"
                        v-if="isGlobalStatsAvailable && !isModerRole"
                    >
                        <router-link
                            :to="{ name: 'Main Stats' }"
                            class="nav-link"
                            id="global_stats"
                        >
                            <em class="nav-icon bi-globe2 mr-2"></em>
                            <p>Global Stats</p>
                        </router-link>
                    </li> -->
                    <!-- Analytics -->
                    <li class="nav-item has-treeview" style="cursor: pointer">
                        <div class="nav-link" id="moder_analytics">
                            <em class="nav-icon bi-file-bar-graph mr-2"></em>
                            <p>
                                Analytics
                                <em class="bi-chevron-right right"></em>
                            </p>
                        </div>
                        <ul class="nav nav-treeview" style="margin: 0 0 0 21px">
                            <li v-if="isGlobalStatsAvailable" class="nav-item">
                                <router-link
                                    class="nav-link"
                                    id="global_overview"
                                    tag="div"
                                    :to="{ name: 'Main Stats' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Global Overview</p>
                                </router-link>
                            </li>
                            <li
                                v-if="isModerRole || isDataExplorerVisible"
                                class="nav-item"
                            >
                                <router-link
                                    class="nav-link"
                                    id="data_explorer"
                                    tag="div"
                                    :to="{ name: 'DataExplorer' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Data Explorer</p>
                                </router-link>
                            </li>
                            <!-- <li v-if="isModerRole || isPerformanceVisible" class="nav-item">
                                <router-link
                                    class="nav-link"
                                    id="client_performance"
                                    tag="div"
                                    :to="{ name: 'ClientPerformance' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Performance</p>
                                </router-link>
                            </li> -->
                            <li v-if="isModerRole || isServerPerformanceVisible" class="nav-item">
                                <router-link
                                    class="nav-link"
                                    id="server_performance"
                                    tag="div"
                                    :to="{ name: 'ServerPerformance' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Server Performance</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <!-- Files -->
                    <li
                        class="nav-item has-treeview"
                        style="cursor: pointer"
                        v-if="isFilesAvailable"
                    >
                        <router-link
                            :to="{ name: 'Files' }"
                            class="nav-link"
                            id="files"
                        >
                            <em class="nav-icon bi-file-earmark-text mr-2"></em>
                            <p>Files</p>
                        </router-link>
                    </li>
                    <!-- Drip Instruments -->
                    <li
                        class="nav-item has-treeview"
                        v-if="isDripsToolsAvailable"
                    >
                        <div class="nav-link" id="drip_instruments">
                            <i class="mr-2 bi-menu-app"></i>
                            <p>
                                Drip Instruments
                                <em class="bi-chevron-right right"></em>
                            </p>
                        </div>
                        <ul class="nav nav-treeview" style="margin: 0 0 0 21px">
                            <li class="nav-item" v-if="isDripManagerAvailable">
                                <router-link
                                    class="nav-link"
                                    id="drip_manager"
                                    tag="div"
                                    :to="{ name: 'Drip Manager' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Drip Manager</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="hasPermissionForCopyTools1">
                                <router-link
                                    class="nav-link"
                                    id="copy_tools"
                                    tag="div"
                                    :to="{ name: 'Copy All Drips New' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Copy Tools</p>
                                </router-link>
                            </li>
                            <li
                                class="nav-item"
                                v-if="hasPermissionForCopyTools2"
                            >
                                <router-link
                                    class="nav-link"
                                    id="copy_tools_2"
                                    tag="div"
                                    :to="{ name: 'Copy All Drips New 2' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Copy Tools 2.0</p>
                                </router-link>
                            </li>
                            <li
                                class="nav-item"
                                v-if="hasPermissionForRecurringMigration"
                            >
                                <router-link
                                    id="recurring_migration"
                                    class="nav-link"
                                    tag="div"
                                    :to="{ name: 'Recurring Migration' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Recurring Migration</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="isDripSetupAvailable">
                                <router-link
                                    class="nav-link"
                                    id="drip_setup"
                                    tag="div"
                                    :to="{ name: 'Drip Setup' }"
                                >
                                    <i class="mr-2 bi-circle"></i>
                                    <p>Drip Setup</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <!-- Tags Presets -->
                    <li
                        class="nav-item has-treeview"
                        style="cursor: pointer"
                        v-if="isTagsManagerAvailable"
                    >
                        <router-link
                            :to="{ name: 'Tags Manager' }"
                            class="nav-link"
                            id="tags_manager"
                        >
                            <em class="nav-icon bi-tags mr-2"></em>
                            <p>Tags Manager</p>
                        </router-link>
                    </li>
                    <!-- Sign Out -->
                    <li class="nav-item has-treeview" style="cursor: pointer">
                        <a
                            class="nav-link"
                            @click.prevent="logoutMethod"
                            id="sign_out"
                        >
                            <em class="nav-icon bi-box-arrow-right mr-2"></em>
                            <p>Sign Out</p>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
        <small class="position-absolute" style="bottom: 0; font-size: 9px"
            >v{{ version }}</small
        >
    </aside>
</template>

<script>
import $ from "jquery";
import { version } from "../../../package.json";
import { mapActions, mapGetters } from "vuex";
import { chunk, pickProperties } from "../../utils";
import transformRecurringToStore from "../../transformers/recurring/transformRecurringToStore";
import recurring from "../../mixins/recurring";
//import User from "../../apis/User";

export default {
    data() {
        return {
            version: version,
            items: [
                {
                    id: 1,
                    name: "Applications :",
                    children: [
                        { id: 2, name: "Calendar : app" },
                        { id: 3, name: "Chrome : app" },
                        { id: 4, name: "Webstorm : app" },
                    ],
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            userName: "name",
            roles: "roles",
            permissions: "permissions",
        }),
        isAllowed() {
            return this.roles.includes("viewer");
        },
        isUserManagementAvailable() {
            return (
                (this.permissions.includes("menu.users.management") ||
                    this.permissions.includes("menu.admin.panel")) &&
                !this.roles.includes("client")
            );
        },
        isDevSettingsAvailable() {
            return this.permissions.includes("menu.admin.panel");
        },
        hasPermissionForCopyTools1() {
            return this.permissions.includes("menu.tools.copy1") || this.roles.includes("moder");
        },
        hasPermissionForCopyTools2() {
            return this.permissions.includes("menu.tools.copy2") || this.roles.includes("moder");
        },
        isGlobalStatsAvailable() {
            return (
                this.permissions.includes("menu.stats.global") ||
                this.permissions.includes("menu.admin.panel") ||
                this.permissions.includes("menu.clients.management")
            );
        },
        isFilesAvailable() {
            return (
                this.permissions.includes("menu.files") ||
                this.permissions.includes("menu.admin.panel")
            );
        },
        isDripsToolsAvailable() {
            return (
                this.permissions.includes("menu.tools") ||
                this.permissions.includes("menu.admin.panel")
            );
        },
        isDripManagerAvailable() {
            return (
                this.permissions.includes("menu.admin.panel") ||
                this.permissions.includes("menu.tools.drip_manager")
            );
        },
        isDripSetupAvailable() {
            return (
                this.permissions.includes("menu.admin.panel") ||
                this.permissions.includes("menu.tools.drip_setup")
            );
        },
        isTagsManagerAvailable() {
            return (
                this.permissions.includes("menu.tags.manager") ||
                this.permissions.includes("menu.admin.panel")
            );
        },
        hasPermissionForRecurringMigration() {
            return this.permissions.includes("menu.tools.recurring_migration");
        },
        isModerRole() {
            return this.roles.includes("moder");
        },
        isDataExplorerVisible() {
            return this.permissions.includes("menu.analytics.data_explorer")
        },
        isPerformanceVisible() {
            return this.permissions.includes("menu.analytics.performance")
        },
        isServerPerformanceVisible() {
            return this.permissions.includes("menu.analytics.server_performance")
        },
    },
    created() {
        // Initialize TreeView.js
        $('[data-widget="treeview"]').Treeview("init");
    },
    methods: {
        ...mapActions(["show", "logout", "resetDomains"]),
        logoutMethod() {
            this.resetDomains();

            this.logout().then(() => {
                localStorage.removeItem("auth");
                //localStorage.removeItem("login");
                this.$router.push({ name: "Home" });
            });
        },
    },
};
</script>

<style>
.v-application ol,
.v-application ul {
    padding-left: 0px !important;
}
.name-block {
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
}
.v-icon:hover {
    filter: contrast(0.5);
}
</style>
